<template>
  <el-dialog
    title="Excel导入"
    :visible.sync="dialogFormVisible"
    custom-class="custom_dialog"
    :close-on-click-modal="false"
  >
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form
          :model="importForm"
          ref="importForm"
          label-width="110px"
          class="demo-ruleForm"
          size="mini"
          :label-position="is_xs ? 'top' : 'left'"
        >
          <el-form-item label="人员分组：" prop="MeetingUserGroupID">
            <el-select
              v-model="selectGroupId"
              placeholder="请选择或者输入分组"
              default-first-option
              @change="
                $forceUpdate()
                groupChange
              "
              @blur="groupBlur"
              :filter-method="dataFilter"
            >
              <el-option
                v-for="item in userGroupList"
                :key="item.MeetingUserGroupID"
                :label="item.MeetingUserGroupName"
                :value="item.MeetingUserGroupID"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择文件：">
            <el-upload
              class="upload-demo"
              ref="upload"
              :file-list="fileList"
              :data="importForm"
              :headers="uploadHeaders"
              action="/api/VoteUser/ImportGroupUsers"
              :show-file-list="true"
              :limit="1"
              :on-success="handleSuccess"
              :on-error="handleError"
              :on-change="changeFile"
              :before-upload="beforeUpload"
              :auto-upload="false"
            >
              <el-button slot="trigger" size="small" type="primary">
                选取文件
              </el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="importGroupUsers()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import voteUserApi from '../../api/vote/voteUser'
export default {
  name: 'ImportExcel',
  data () {
    return {
      importForm: {
        MeetingUserGroupID: null,
        MeetingID: null
      },
      dialogFormVisible: false,
      MeetingGroupId: null,
      userGroupList: [],
      listQuery: {
        meetingId: null,
        maxResultCount: 10000,
        skipCount: 0
      },
      fileList: [],
      uploadHeaders: {
        Authorization: null
      },
      inputGroupName: '',
      selectGroupId: null
    }
  },
  props: {
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    getDefaultUserGroup: function () {
      voteUserApi.getDefaultUserGroup({
        meetingId: this.importForm.MeetingID
      }).then(data => {
        if (data) {
          this.selectGroupId = data.MeetingUserGroupID
        } else {
          this.userGroupList.unshift({ MeetingUserGroupID: null, MeetingUserGroupName: '默认组', Sort: 0 })
          this.selectGroupId = null
        }
        if (this.MeetingGroupId) {
          this.selectGroupId = this.MeetingGroupId
        }
        this.openLoading().close()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    getVoteUserGroups: function () {
      voteUserApi.getVoteUserGroups(this.listQuery).then(data => {
        this.userGroupList = data.Items
        this.getDefaultUserGroup()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    openImportExcel: function (MeetingGroupId, meetingId) {
      this.openLoading()
      this.dialogFormVisible = true
      this.MeetingGroupId = MeetingGroupId
      this.selectGroupId = MeetingGroupId
      this.listQuery.meetingId = meetingId
      this.importForm = {}
      this.fileList = []
      this.importForm.MeetingID = meetingId
      this.importForm.MeetingUserGroupID = this.selectGroupId
      this.getVoteUserGroups()
      const state = JSON.parse(window.localStorage.getItem('state'))
      this.uploadHeaders.Authorization = 'Bearer ' + state.token
    },
    changeFile (file, filelist) { // 文件状态改变时的钩子 把filelist 赋值给data中的filelist
      this.fileList = filelist
    },
    handleSuccess (res, file) {
      this.$message({
        showClose: true,
        type: 'success',
        message: '导入成功！',
        customClass: 'custom_message'
      })
      this.dialogFormVisible = false
      this.fatherSubmitDialog()
    },
    handleError (err, file, fileList) {
      this.$message({
        showClose: true,
        type: 'error',
        message: err.message,
        customClass: 'custom_message'
      })
    },
    beforeUpload (file) {
      const isJPG = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel'
      const isLt2M = file.size / 1024 / 1024 < 10

      if (!isJPG) {
        this.$message({
          showClose: true,
          type: 'error',
          message: '只能导入excel文件！',
          customClass: 'custom_message'
        })
      }
      if (!isLt2M) {
        this.$message({
          showClose: true,
          type: 'error',
          message: '导入文件大小不能超过 10MB！',
          customClass: 'custom_message'
        })
      }
      return isJPG && isLt2M
    },
    importGroupUsers: function () {
      if (this.fileList.length) { // 判断data中的filelist是否有数据 没有则未选中文件
        this.$refs.upload.submit() // 手动上传文件
      } else {
        this.$message({
          showClose: true,
          type: 'error',
          message: '请选择文件！',
          customClass: 'custom_message'
        })
      }
    },
    groupChange: function (item) {
      const _this = this
      _this.selectGroupId = item
      _this.importForm.MeetingUserGroupID = _this.selectGroupId
    },
    groupBlur: function (event) {
      if (this.inputGroupName.length > 0) {
        this.groupChange(this.inputGroupName)
      }
    },
    dataFilter: function (val) {
      this.inputGroupName = val
    }
  },
  created () {

  }
}
</script>
<style lang="less">
</style>
